const isObject = (v: any) => v && typeof v === 'object' && !Array.isArray(v);

const deepMerge = <T extends Record<string, any>>(target: T, source: Partial<T>): T => {
  const result = { ...target };

  for (const key in source) {
    const srcVal = source[key];
    const tgtVal = target[key];

    if (Array.isArray(srcVal)) {
      result[key] = srcVal as any;
    } else if (isObject(srcVal) && isObject(tgtVal)) {
      result[key] = deepMerge(tgtVal, srcVal as any);
    } else if (srcVal !== undefined) {
      result[key] = srcVal as any;
    }
  }

  return result;
};

export default deepMerge;
